// 삼성 SDS / V2 식대 상세조회 전용 comId 입니다.
const DETAILED_SIKDAE_ALLOWED_COM_ID_LIST = [
  'B068366F-5EB8-1C7E-E79C-D438C8E32F9D',
  '721C8B3F-1A9E-4B3E-855A-B7B8CE624167'
];

export const isDetailedSikdaeSamsungSdsAllowedCompany = (companyId) =>
  DETAILED_SIKDAE_ALLOWED_COM_ID_LIST.includes(companyId);
